import React from 'react';
import { StarIcon, WrenchIcon } from 'lucide-react';
import { yearPlan } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per quarter (full class names so Tailwind keeps them). Dark text on coral, green and yellow for contrast. */
const quarterStyles = [{
  band: 'bg-brand text-white',
  star: 'text-brand'
}, {
  band: 'bg-coral text-ink',
  star: 'text-coral-ink'
}, {
  band: 'bg-leaf text-ink',
  star: 'text-leaf-ink'
}, {
  band: 'bg-sun text-ink',
  star: 'text-ink'
}];

/** The 52-week plan, quarter by quarter */
export function YearPlanSection() {
  return <section id="year" aria-labelledby="year-title" className="scroll-mt-4 bg-white py-12 md:py-20" data-id="element-249" data-mp="32kx24j4mgiod">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-250" data-mp="37cx56kfznrp6">
        <SectionHeading id="year-title" eyebrow={yearPlan.eyebrow} title={yearPlan.title} sub={yearPlan.sub} data-id="element-251" data-mp="37dq10qdeswsj" />

        <ol className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-252" data-mp="2evb07nwv7pco">
          {yearPlan.quarters.map((q, qi) => {
          const s = quarterStyles[qi % quarterStyles.length];
          return <li key={q.q} className="flex flex-col overflow-hidden rounded-xl border border-hair bg-white" data-id="element-253" data-mp="1va4p4dd2h6uj" data-mpi={qi}>
                <div className={`flex items-baseline justify-between gap-3 px-5 py-3 ${s.band}`} data-id="element-254" data-mp="1qiwbf54pezbk">
                  <span className="font-display text-[1.6rem] font-black leading-none" data-id="element-255" data-mp="1ljs46k1cbbnv">{q.q}</span>
                  <span className="font-display text-[12px] font-extrabold tracking-[0.1em]" data-id="element-256" data-mp="1gmtau3pi38qq">{q.weeks}</span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-257" data-mp="1blcaqaeubqb7">
                  <h3 className="font-display text-[16px] font-black tracking-[0.04em] text-ink" data-id="element-258" data-mp="17kab3sh0hc8p">{q.name}</h3>
                  <ul className="mt-4 space-y-3" data-id="element-259" data-mp="12n0mug5cz6mg">
                    {q.full.map(m => <li key={`${q.q}-${m.week}`} className="flex gap-3" data-id="element-260" data-mp="31zct753qds1l">
                        <StarIcon className={`mt-0.5 h-4 w-4 shrink-0 fill-current ${s.star}`} aria-hidden="true" data-id="element-261" data-mp="2x09rnumym3yd" />
                        <div className="min-w-0" data-id="element-262" data-mp="3g4d5t0xvgar0">
                          <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-263" data-mp="3g2imfr290qp1">
                            WEEK {m.week} · MEETING {m.n}
                          </p>
                          <p className="font-display text-[15px] font-bold leading-snug text-brand" data-id="element-264" data-mp="375i1xviavcqv">{m.title}</p>
                        </div>
                      </li>)}
                  </ul>
                  <p className="mt-auto pt-4 text-[14px] leading-snug text-ink/70" data-id="element-265" data-mp="3l3vdxiuvd0y">{q.activities}</p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mx-auto mt-6 max-w-[900px] rounded-xl bg-sun-soft p-5 md:mt-8 md:p-6" data-id="element-266" data-mp="3ptn1srvu6dke">
          <div className="flex items-center gap-3" data-id="element-267" data-mp="3us7y4g7ywd3k">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sun text-ink" data-id="element-268" data-mp="2efj6nidiijdr">
              <WrenchIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-269" data-mp="2jevsbzsndker" />
            </span>
            <h3 className="font-display text-[14px] font-black tracking-[0.08em] text-ink" data-id="element-270" data-mp="2bubq31s8hydd">{yearPlan.toolsTitle}</h3>
          </div>
          <ul className="mt-4 grid gap-2.5 md:grid-cols-3 md:gap-4" data-id="element-271" data-mp="26uytvqfh3ey4">
            {yearPlan.tools.map(t => <li key={t} className="rounded-lg bg-white px-4 py-3 text-[15px] font-medium leading-snug text-ink" data-id="element-272" data-mp="2kuqfac8bjxm5">
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}